import { render, staticRenderFns } from "./ClassEdit.vue?vue&type=template&id=53b7e2c5&"
import script from "./ClassEdit.vue?vue&type=script&lang=js&"
export * from "./ClassEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports